import React from 'react';
import { PropTypes } from 'prop-types';
import { Formik, Form } from 'formik';

// Components
import ButtonOutlineWithStates from '@atoms/ButtonOutlineWithStates';
import SubmitButton from '@atoms/SubmitButton';
import TextInput from '@atoms/TextInput';
import { BodyLarge, DividerLightGreyStyled, H4, LabelSmall } from '@styled';

// Functionality
import { generateSavedSearchTitle } from '../../../../../helpers/savedSearches.helpers';

const MatchCriteriaTitle = ({ data, submitButtonClass, onNext, onBack }) => {
    const onFormSubmit = values => {
        onNext(values);
    };

    return (
        <div>
            <div className="container-fluid">
                <div className="mb-1rem">
                    <LabelSmall>Step 3 of 3</LabelSmall>
                </div>

                <div className="row">
                    <div className="col-12 col-lg-8" style={{ minHeight: '400px' }}>
                        <H4 className="mb-0">Title Your Match Criteria</H4>
                        <DividerLightGreyStyled className="mt-0.5rem mb-2rem" />

                        <BodyLarge className="mb-2rem">
                            Add a custom title to your match criteria or use the generated title below. You can edit the
                            title and match criteria at any time.
                        </BodyLarge>

                        <Formik
                            onSubmit={onFormSubmit}
                            initialValues={{
                                ...data,
                                title: generateSavedSearchTitle(data),
                            }}
                        >
                            {({ errors, isValid, submitCount }) => (
                                <Form errors={errors}>
                                    {!isValid && submitCount > 0 && (
                                        <div className="alert alert-danger">
                                            There were issues with your submission.
                                        </div>
                                    )}

                                    <TextInput name="title" placeholder="Title your search." />

                                    <div className="d-md-flex">
                                        <ButtonOutlineWithStates buttonClasses="mr-2" onClick={onBack}>
                                            Back to Previous
                                        </ButtonOutlineWithStates>
                                        <SubmitButton buttonClasses={submitButtonClass}>Save</SubmitButton>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    );
};

MatchCriteriaTitle.propTypes = {
    data: PropTypes.any,
    submitButtonClass: PropTypes.string,
    onBack: PropTypes.func,
    onNext: PropTypes.func,
};

export default MatchCriteriaTitle;
